module.exports = __webpack_public_path__ + "img/articleALaMaison.203fef8e.png";